export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4855.baf7e82a.jpg";